import React, { useEffect } from 'react';
import './ReturnsPolicyBottomSheet.css';

const ReturnsPolicyBottomSheet = ({ isOpen, onClose }) => {
    // Prevent scrolling on body when bottom sheet is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    return (
        <>
            <div className={`returns-overlay ${isOpen ? 'show' : ''}`} onClick={onClose}></div>
            <div className={`returns-bottom-sheet ${isOpen ? 'show' : ''}`}>
                <div className="returns-sheet-header">
                    <div className="returns-drag-handle" onClick={onClose}></div>
                    <button className="returns-close-btn" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                
                <div className="returns-sheet-content">
                    <div className="returns-header-section">
                        <h1 className="returns-title returns-font-heading">Refund Policy</h1>
                        <p className="returns-subtitle" style={{ marginBottom: '15px' }}>
                           We offer a 30-day return policy for dry groceries and kitchenware. To qualify, items must be unused, 
in original packaging, and accompanied by proof of purchase.
                        </p>
                        <p className="returns-subtitle">
                        To start a return, email aarohfood@gmail.com. Returns without prior approval will not be accepted.
                        </p>
                    </div>

                    <div className="returns-section">
                        <h3 className="returns-font-heading">Damages and Issues</h3>
                        <p>Please check your order carefully as soon as it arrives. If anything is damaged, defective, or incorrect, contact us straight away so we can sort it out for you.</p>
                        <ul>
                            <li>For fresh and frozen items, complaints must be raised <strong>within 24 hours</strong> of delivery, along with clear images of the item.</li>
                            <li>For damaged or expired grocery items, complaints must be raised <strong>within 7 days</strong>, with photo or video proof.</li>
                            <li>For missing parcels or incorrect delivery status, please raise a complaint <strong>within 3 days</strong> of the expected delivery date.</li>
                        </ul>
                    </div>

                    <div className="returns-section">
                        <h3 className="returns-font-heading">Exceptions / Non-Returnable Items</h3>
                        <p>Certain items cannot be returned, including:</p>
                        <ul>
                            <li><strong>Perishable goods</strong> fresh vegetables, fruits, flowers, frozen products, meat, fish, fresh sweets and snacks, and plants</li>
                            <li><strong>Custom or personalized items</strong> special orders made to your specifications</li>
                            <li><strong>Personal care products</strong> such as beauty and grooming items</li>
                            <li><strong>Hazardous materials</strong> including flammable liquids or gases</li>
                            <li><strong>Sale items and gift cards</strong> unfortunately, these cannot be returned or refunded</li>
                        </ul>
                        <p>If you're unsure whether your item qualifies, don't hesitate to contact us and we'll be glad to advise.</p>
                    </div>

                    <div className="returns-section">
                        <h3 className="returns-font-heading">Refund & Complaint Policy</h3>
                        <ul>
                            <li>Complaints for <strong>fresh and frozen items</strong> must be raised within <strong>24 hours</strong> of delivery, with supporting images.</li>
                            <li>Complaints for <strong>damaged or expired grocery items</strong> must be raised within <strong>7 days</strong>, with photo or video proof.</li>
                            <li>For <strong>missing parcels or incorrect delivery status</strong>, complaints must be raised within <strong>3 days</strong> of delivery.</li>
                        </ul>
                        <p>Once we receive and inspect your returned item, we'll let you know whether your refund has been approved. If approved, the refund will be processed back to your original payment method. Please bear in mind that your bank or card provider may take a few additional days to reflect the amount in your account.</p>
                        
                        <p><strong>Please note:</strong></p>
                        <ul>
                            <li>Refunds will be issued after deducting applicable packaging and handling charges.</li>
                            <li>No refund will be provided for perishable items once the order has been dispatched.</li>
                            <li>If a delivery attempt fails, or if the delivery is refused or returned to us, no refund will be issued for perishable items.</li>
                            <li>If there is a delivery delay, please report it to us immediately.</li>
                        </ul>

                        <p>Refunds may be delayed or require further evidence in the following situations:</p>
                        <ol>
                            <li>No photo or video evidence is provided.</li>
                            <li>Temperature-controlled delivery was not selected for perishable products.</li>
                            <li>The delivery attempt failed, was refused, or returned under avoidable circumstances.</li>
                        </ol>
                    </div>

                    <div className="returns-section">
                        <h3 className="returns-font-heading">Exchanges</h3>
                        <p style={{marginBottom: '10px', fontWeight: '600'}}>Return Policy</p>
                        <ul>
                            <li><strong>No returns</strong> are accepted for fresh or frozen items</li>
                            <li>For <strong>grocery items</strong>:
                                <ul style={{marginTop: '10px', paddingLeft: '20px', listStyleType: 'circle'}}>
                                    <li>Complaints must be raised within <strong>30 days</strong> of delivery.</li>
                                    <li>If the complaint is found to be valid, we will arrange a return or suitable resolution.</li>
                                    <li>If you're unsatisfied with your purchase or ordered by mistake, the item will need to be brought back to the store by you we do not offer a collection service in such cases.</li>
                                </ul>
                            </li>
                        </ul>
                    </div>

                    <div className="returns-section">
                        <h3 className="returns-font-heading">Cancellation Policy</h3>
                        <p>If you wish to cancel your order, please be aware that a <strong>£2.99 cancellation/processing fee</strong> will be deducted from your refund. This small charge helps us manage our operations and continue providing you with the reliable service you deserve.</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReturnsPolicyBottomSheet;
